import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import React, { useRef } from "react";

const Tools = () => {
  const container = useRef();
  const marquee1 = useRef();
  const marquee2 = useRef();

  useGSAP(() => {
    // Right-to-left marquee (Standard)
    gsap.to(marquee1.current, {
      xPercent: -50,
      repeat: -1,
      duration: 15,
      ease: "none",
    });

    // Left-to-right marquee (Reverse)
    // Set initial position to -50% then animate back to 0%
    gsap.set(marquee2.current, { xPercent: -50 });
    gsap.to(marquee2.current, {
      xPercent: 0,
      repeat: -1,
      duration: 18,
      ease: "none",
    });
  }, { scope: container });

  const tags1 = [
    "Avatar", "Technology", "Design", "Artificial Intelligence", 
    "AI Chat Bot", "Customizable", "3D Model", "Engineering"
  ];

  const tags2 = [
    "Artificial Intelligence", "People", "Create Videos", "Analyze",
    "Outfits", "3d Model", "Voice Chat", "Marketing", "Realistic"
  ];

  const Tag = ({ text, gradient }) => (
    <span className={`rounded-full md:text-2xl text-sm min-w-max border border-white/10 backdrop-blur-md bg-gradient-to-r ${gradient} px-8 py-4 mx-4 shadow-lg hover:scale-110 transition-transform cursor-default whitespace-nowrap`}>
      {text}
    </span>
  );

  return (
    <div ref={container} className="py-32 overflow-hidden bg-slate-950/50">
      <div className="flex whitespace-nowrap" ref={marquee1}>
        {[...tags1, ...tags1].map((tag, i) => (
          <Tag key={i} text={tag} gradient={i % 2 === 0 ? "from-[#284453] to-[#1e293b]" : "from-[#5a2459] to-[#1e293b]"} />
        ))}
      </div>
      
      <div className="flex whitespace-nowrap mt-10" ref={marquee2}>
        {[...tags2, ...tags2].map((tag, i) => (
          <Tag key={i} text={tag} gradient={i % 2 === 0 ? "from-[#5a2459] to-[#1e293b]" : "from-[#284453] to-[#1e293b]"} />
        ))}
      </div>
    </div>
  );
};

export default Tools;
